import { ITag } from "../interface/tag";
export class Tag implements ITag {
  constructor(
    public TagId: number,
    public TagText: string,
    public UserName: string,
    public CreatedDate: Date
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/section/master/model/tag.ts